import { Allotment } from "allotment";
import { CommentPanelInner } from "components/common/comments/CommentPanel";
import ErrorBoundary from "components/common/ErrorBoundary";
import { HierarchyTopBar } from "components/hierarchypage/HierarchyTopBar";
import { TlfInner } from "components/tlfpage/Tlf";
import { TocTree } from "components/toc/TocTree";
import { BottomNav } from "components/topbar/BottomNav";
import { useTlfContext } from "contexts/AppSettingsContext";
import { HierarchyContextProvider } from "contexts/HierarchyContextProvider";
import { TlfContextProvider } from "contexts/TlfContextProvider";
import { TocContextProvider } from "contexts/TocContextProvider";
import { Container } from "react-bootstrap";
import { Outlet } from "react-router-dom";

/**
 * The TlfReview page
 */
export const TlfReview = (): React.ReactElement => (
  <ErrorBoundary>
    <HierarchyContextProvider>
      <TocContextProvider>
        <HierarchyTopBar />
        <div className="col-between-top-and-bottom">
          <Allotment defaultSizes={[1, 5]}>
            <Allotment.Pane>
              <div className="small-scrollbar col-between-top-and-bottom">
                <TocTree />
              </div>
            </Allotment.Pane>
            <Allotment.Pane>
              <Outlet />
            </Allotment.Pane>
          </Allotment>
        </div>
        <BottomNav />
      </TocContextProvider>
    </HierarchyContextProvider>
  </ErrorBoundary>
);

TlfReview.displayName = "TlfReview";

/**
 * Right hand side of the TlfReview page
 */
export const TlfReviewRHS = (): React.ReactElement => {
  return (
    <TlfContextProvider readOnly>
      <TlfReviewContent />
    </TlfContextProvider>
  );
};

/**
 * Renders the active review TLF, or an empty state when the route has no selected item.
 */
const TlfReviewContent = (): React.ReactElement => {
  const { tlfData } = useTlfContext();

  return !tlfData ? (
    <div className="w-100 d-flex align-items-center justify-content-center">No Tlf loaded</div>
  ) : (
    <Allotment defaultSizes={[4, 1]}>
      <Allotment.Pane>
        <div className="small-scrollbar col-between-top-and-bottom">
          <Container>
            <TlfInner />
          </Container>
        </div>
      </Allotment.Pane>
      <Allotment.Pane>
        <div className="small-scrollbar col-between-top-and-bottom">
          <CommentPanelInner activeContext="TlfItem" />
        </div>
      </Allotment.Pane>
    </Allotment>
  );
};

TlfReviewContent.displayName = "TlfReviewContent";

TlfReviewRHS.displayName = "TlfReviewRHS";

export default TlfReview;
